module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pageTitle":"Shop"},"en":{"pageTitle":"Shop"}}')
  delete Component.options._Ctor
}
